<template>
    <section class="flex font-poppins md:flex-col">
        <div >
                <AdminDashboardNav/>
        </div> 
        <div class="w-screen  pl-10 pr-10 md:p-2" >
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-xl">MANAGE DSOS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            
            <div class="mb-10 mt-20 md:m-3">
                <div class="flex">
                    <i class="fa fa-arrow-left mt-1 text-blue-700"></i>
                    <button @click="goBack" class="text-sm ml-4 text-blue-700 cursor-pointer"  >Go Back</button>
                    <p class=" ml-8 font-semibold text-lg md:text-sm">Dso's Information</p>
                    <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                </div>
            </div>
            
            <section class="md:text-sm flex justify-between  md:flex-col">
                <div class=" flex ">
                    <img src="../assets/customer-pic1.png" alt="pic">
                    <button class="mt-4 cursor-pointer rounded-2xl ml-6  border-blue-400 text-center p-2 bg-green-100 text-green-300 font-semibold" >
                        <span v-if="dso.status === 'approved' " class="pl-4 pr-4 text-red-500" @click="blockDso(dso)">Block</span>
                        <span v-if="dso.status === 'blocked' " class="pl-4 pr-4 text-red-500" @click="unblockDso(dso)">Unblock</span>
                        <span @click="approveDso" v-if="dso.status === 'pending' " class="pl-4 pr-4" style=" color: rgb(243, 243, 9);">Approve</span>
                    </button>
                    <div class="flex ml-6 border bg-gray-200 p-2  text-center mt-4 rounded-xl cursor-pointer">
                        <img class="w-5 h-5 mr-2" src="../assets/message-icon.png"/>
                        <router-link :to="{name: 'email-center'}">Send Email</router-link>
                    </div>
                </div>

            <div class="md:mt-4 md:text-right">
                <button @click="deleteDsoModal(dso)" class="bg-red-100 text-red-600 rounded-xl p-2"><i class="fa fa-trash mr-2"></i>Delete</button>
            </div>
                
            </section>


            <section class="flex justify-between mt-6 text-blue-600">
                <div class="flex">
                    <img src="../assets/user-icon.svg" alt="user-icon">
                    <p class="ml-6 md:ml-1">Profile Details</p>
                </div>
                

                <div>
                    <p class="mr-28 cursor-pointer md:mr-1">Attachment(s)</p>
                </div>
            </section>
            <hr>

            <section class="flex justify-between md:flex-col ">
                <div class="flex mt-6 w-1/2">
                    <div >
                        <div class="flex">
                            <p> Status: </p>
                            <p class="ml-4 text-blue-600">{{dso.status}}.</p>
                        </div>
                         <div class="flex">
                            <p class="mt-4"> Name: </p>
                            <p class="mt-4 ml-4 text-blue-600">{{dso.firstName}}  {{dso.lastName}}.</p>
                        </div>
                        <div class="flex">
                            <p class="mt-4">Email:</p>
                            <p class="mt-4 ml-4 text-blue-600" >{{dso.email}}.</p>
                        </div>
                        <div class="flex">
                            <p class="mt-4">Carrier Mode</p>
                            <p class="mt-4 ml-4 text-blue-600">{{dso.carrierMode}}.</p>
                        </div>
                        <div class="flex">
                            <p class="mt-4"> Location:</p>
                            <p class="mt-4 ml-4 text-blue-600">{{dso.country}}, {{dso.state}}.</p>
                        </div>
                        <div class="flex">
                            <p class="mt-4">Date Joined:</p>
                            <p class="mt-4 ml-4 text-blue-600">{{moment(dso.dateRegistered).format("MM/DD/YYYY")}}.</p>
                        </div>
                        <div v-show="dso.companyName " class="flex">
                            <p class="mt-4">Company Name:</p>
                            <p class="mt-4 ml-4 text-blue-600">{{dso.companyName}}.</p>
                        </div>
                        <div v-show="dso.companyDescription " class="flex">
                            <p class="mt-4">Company Description:</p>
                            <p class="mt-4 ml-4 text-blue-600">{{dso.companyDescription}}.</p>
                        </div>
                        
                    </div>

                    <div class="ml-10 text-blue-600">
                    </div>
                </div>

                <div class=" mr-10 mt-6 w-1/3 md:w-full">

                    <div>
                        <div class="flex">
                            <div v-if="dso.vehicleReceipt && dso.vehicleReceipt.includes('pdf')"  class=" w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.vehicleReceipt" target="_blank"><img class="w-full h-32 " src="../assets/pdf.png" alt="pic"></a>
                            </div>
                            <div v-else class=" w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.vehicleReceipt" target="_blank"><img class="w-full h-32 " :src="dso.vehicleReceipt" alt="pic"></a>
                            </div>
                            <div v-if="dso.hackneyPermit && dso.hackneyPermit.includes('pdf')"  class="ml-8 w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.hackneyPermit" target="_blank"><img class="w-full h-32 " src="../assets/pdf.png" alt="pic"></a>
                            </div>
                            <div v-else-if="dso.carrierMode !== 'CabHailing'"  class="ml-8 w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.hackneyPermit" target="_blank"><img class="w-full h-32 " :src="dso.hackneyPermit" alt="pic"></a>
                            </div>
                            <!-- <div v-else  class="ml-8 w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.hackneyPermit" target="_blank"><img class="w-full h-32 " :src="dso.hackneyPermit" alt="pic"></a>
                            </div> -->
                        </div>

                        <div class="flex mt-8">
                            <div v-if="dso.cac && dso.cac.includes('pdf')" class=" w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.cac" target="_blank"><img class="w-full h-32 " src="../assets/pdf.png"  alt="pic"></a>
                            </div>
                            <div v-else-if="dso.carrierMode !== 'CabHailing'" class=" w-1/3 md:w-1/2 h-32 rounded-xl bg-gray-200">
                                <a :href="dso.cac" target="_blank"><img class="w-full h-32 " :src="dso.cac" alt="pic"></a>
                            </div>
                            <!-- <div class="ml-8 md:w-1/2 w-1/3 h-32 rounded-xl bg-gray-200 border border-black border-dashed">
                                <a :href="dso.roadWorthiness" target="_blank"><img class="w-full h-32 " :src="dso.roadWorthiness" alt="pic"></a>
                            </div> -->
                        </div>
                    </div>   
                           
                </div>    
            </section>
        </div>  

         <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getDsos="getDso"
            :dsoId="dsoId"
            />
        </div>        
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import DeleteModal from './DeleteModal.vue';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props: ['id'],
    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        DeleteModal
    },

    data() {
        return {
            dsoInfo: true,
            pendingDsos: false,
            isLoading: false,
            dso: [],
            isActive: false,
            token: localStorage.getItem("token"),
            blockStatus: "blocked",
            unblockStatus: "approved",
            deleteModal: false,
            message: "",
            dsoId: "",
            status: "approved"
        }
    },

    mounted() {
        this.getDso();
        this.networkError();
    },

    methods: {
         moment(date) {
            return moment(date);
        },

        closeModal() {
            this.deleteModal = false;
        },
        deleteDsoModal(dso) {
            this.dsoId = dso._id
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        goBack() {
           this.$router.go(-1)
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        },
        approveDso() {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${this.dso._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.status
                }
            })
            .then((response) => {
                this.getDso()
                console.log(response)
            }) 
            .catch((error) => {
                console.log(error)
            })
        },
        blockDso(dso) {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                this.getDso()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        unblockDso(dso) {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/dsos/update/status/${dso._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getDso()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        getDso() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/dsos/check/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response)=> {
                this.dso = response.data.data
                this.isLoading = false
            })
            .catch((error) => {
                console.log(error)
            })
        }

        
    }
}
</script>

